@if (isLoading && !displayedItems?.length) {
<app-loading-indicator [isLoading]="isLoading" class="load-indicator" id="scimIntegrationsPage"></app-loading-indicator>
}

<div class="ziti-page-container lt-skin-page">
    <lib-list-table-header
        title="Integrations"
        subtitle="Sync identities from your identity provider using SCIM"
        createLabel="Create SCIM Integration"
        infoText="A SCIM integration provides a URL and authentication method that your identity provider uses to sync identities into your network."
        [tabs]="tabs"
        [showAdd]="!hasSelection"
        [blockCreate]="createBlocked"
        [blockDelete]="!canDeleteSelection"
        (actionClicked)="onHeaderAction($event)"
    >
        <span header-icon class="icon-integrations" aria-hidden="true"></span>
    </lib-list-table-header>

    <lib-list-table
        class="lt-skin"
        [tableId]="tableId"
        [initialPageSize]="initialPageSize"
        [options]="tableOptions"
        [columns]="columns"
        [rowData]="rows"
        [isLoading]="isLoading"
        [hasNext]="hasNext"
        [hasPrev]="hasPrev"
        [startCount]="startCount"
        [endCount]="endCount"
        [totalCount]="svc.lastTotalCount"
        [filterApplied]="filterApplied"
        [filterColumn]="searchFilter"
        [menuItems]="menuItems"
        [headerActions]="headerActions"
        filterName="Name"
        entityTypeName="SCIM integrations"
        noItemsImage="nodata"
        [showNoItemsAdd]="!createBlocked"
        [noItemsReadonly]="createBlocked"
        (actionRequested)="onAction($event)"
    ></lib-list-table>
</div>
